import React, { useEffect, useRef, useState } from "react";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import useMap from "./useMap";
import DfrMap from "./dfrMap";
import { ConvertDfrToFeatures, FetchTelemetry, JumpToFeatures } from "./dfrUtil";

export default function DfrFlightMap({ dfr }) {
    const MAP_ID = `map-dfr-${dfr.flight_uuid}`;
    const map = useMap(MAP_ID);
    const source = useRef(new VectorSource());
    const [telemetry, setTelemetry] = useState(null);

    useEffect(() => {
        if (map) {
            map.addLayer(new VectorLayer({ source: source.current, zIndex: 1 }));
        }
    }, [map]);

    useEffect(() => {
        if (!dfr.telemetry) {
            return;
        }

        let active = true;
        FetchTelemetry(dfr).then((data) => {
            if (active && data) {
                setTelemetry(data);
            }
        });

        return () => {
            active = false;
        };
    }, [dfr]);

    useEffect(() => {
        if (!map) {
            return;
        }

        const features = ConvertDfrToFeatures(dfr, telemetry);
        source.current.clear();
        source.current.addFeatures(features);
        JumpToFeatures(map, features);
    }, [map, dfr, telemetry]);

    return <DfrMap id={MAP_ID} />;
}
